import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { GuideButtonsContainer } from './style'

function GuideButtons({
  onPrevious = null,
  onNext = null,
  onSave = null,
  disabled = false,
}) {
  const { t } = useTranslation()

  return (
    <GuideButtonsContainer className="pl-3 pr-3 ml-3 mr-3 mt-1 actions">
      {onPrevious && (
        <Button className="btn-white btn-dash" onClick={onPrevious}>
          {t('previous')}
        </Button>
      )}
      {onNext && (
        <Button
          className="btn-blue btn-next btn-dash ml-2"
          disabled={disabled}
          onClick={onNext}
        >
          {t('next')}
        </Button>
      )}
      {onSave && (
        <Button
          className="btn-blue btn-next btn-dash ml-2"
          disabled={disabled}
          onClick={onSave}
        >
          {t('save_changes')}
        </Button>
      )}
    </GuideButtonsContainer>
  )
}

export default GuideButtons
